import gql from 'graphql-tag';

export default gql`
query listFA_CustomerOrderReportID($languageId: Int){
    fakturaAssist{
    listFA_CustomerOrderReportID(languageId: $languageId){
		id
        form
        name
        formId
        formIdDefault
    }
    
  }
}`;
